/**

 * ewc-bundle — ofertas por quantidade na página de produto, independente de tema.

 *

 * O widget nasce escondido no fim do body e o JS o leva para logo acima do botão de

 * compra, achando sozinho o formulário de /cart/add que o cliente de fato envia

 * (não o da gaveta, não o do upsell). A partir daí ele intercepta o envio e monta o

 * pedido: as unidades da barra escolhida (cada uma com a variante escolhida), os

 * upsells marcados e os brindes liberados — tudo pelo /cart/add.js.

 *

 * O desconto NÃO é aplicado aqui: o widget mostra a conta que o checkout vai

 * cobrar (a mesma do ofertas.py). Quem cobra é o desconto automático da loja.

 *

 * Falha aberto: qualquer erro deixa a página e o botão do tema como estavam.

 */

(function () {

  'use strict';

  if (window.EwcBundle) return;



  var SEL_PICKER = 'variant-selects,variant-radios,variant-picker,.product-variant-picker,.product-form__variants,[data-product-option],.product-form__input--dropdown,.product-form__input--pill,.product-form__input--swatch';

  var SEL_FORA = 'cart-drawer,.cart-drawer,#shopify-section-cart-drawer,#ewc-cart-root,[data-is-cart-upsell],.upsell,.upsells-container,.drawer,.cart-drawer-upsells-container,.ewc-cart';



  function el(tag, classe, texto) { var n = document.createElement(tag); if (classe) n.className = classe; if (texto != null) n.textContent = texto; return n; }

  function dinheiro(cent, fmt) {

    var v = (cent / 100).toFixed(2), p = v.split('.'), i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/g, i + '.' + p[1]).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, i)

      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.') + ',' + p[1]).replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, i.replace(/,/g, '.')).replace(/<[^>]*>/g, '');

  }

  function enxuto(t) { return String(t).replace(/(\d)\.00(?!\d)/g, '$1'); }

  // preço formatado: os centavos redondos só caem quando `mostrar.sem_decimais` pede

  Widget.prototype.money = function (cent) {

    var s = dinheiro(cent, this.fmt);

    return (this.cfg.mostrar || {}).sem_decimais ? enxuto(s) : s;

  };



  /* ------------------------------------------------------ formulário de compra */

  function achar(root, seletorManual) {

    if (seletorManual) { var m = document.querySelector(seletorManual); if (m) return m; }

    function temBotao(f) { return !!f.querySelector('button[name="add"],[type="submit"]'); }

    function deFora(f) { return !!(f.closest && f.closest(SEL_FORA)); }

    var comId = null, comBotao = null, qualquer = null;

    var forms = document.querySelectorAll('form[action*="/cart/add"]');

    for (var i = 0; i < forms.length; i++) {

      var f = forms[i]; if (deFora(f) || root.contains(f)) continue;

      var id = !!f.querySelector('[name="id"]'), botao = temBotao(f);

      if (id && botao) return f;

      if (id && !comId) comId = f; if (botao && !comBotao) comBotao = f; if (!qualquer) qualquer = f;

    }

    return comBotao || comId || qualquer;

  }

  function posicionar(root, form) {

    var alvo = form.querySelector('.product-form__buttons') || form.querySelector('button[name="add"]') || form.querySelector('[type="submit"]') || form;

    if (alvo !== form && alvo.closest) alvo = alvo.closest('.product-form__buttons') || alvo;

    var subir = alvo.closest ? alvo.closest('product-form,.product-form,.product-form__buttons-wrapper') : null;

    if (subir && subir.parentNode && subir !== form.parentNode) alvo = subir;

    if (!alvo.parentNode) return false;

    alvo.parentNode.insertBefore(root, alvo);

    root.hidden = false;

    return true;

  }



  /* ------------------------------------------------------ variantes */

  function Variantes(produto) {

    this.p = produto; this.opcoes = produto.opcoes || []; this.v = produto.variantes || [];

  }

  Variantes.prototype.porOpcoes = function (escolha) {

    for (var i = 0; i < this.v.length; i++) { var ok = true; for (var j = 0; j < escolha.length; j++) if (this.v[i].opcoes[j] !== escolha[j]) { ok = false; break; } if (ok) return this.v[i]; }

    return null;

  };

  Variantes.prototype.valoresDisponiveis = function (indice, prefixo) {

    // valores da opção `indice` que existem (e estão disponíveis) dado o prefixo já escolhido

    var vistos = {}, lista = [];

    for (var i = 0; i < this.v.length; i++) {

      var ok = true; for (var j = 0; j < indice; j++) if (this.v[i].opcoes[j] !== prefixo[j]) { ok = false; break; }

      if (!ok) continue;

      var val = this.v[i].opcoes[indice];

      if (!(val in vistos)) { vistos[val] = false; lista.push(val); }

      if (this.v[i].disponivel) vistos[val] = true;

    }

    return lista.map(function (x) { return { valor: x, disponivel: vistos[x] }; });

  };

  Variantes.prototype.porId = function (id) { for (var i = 0; i < this.v.length; i++) if (String(this.v[i].id) === String(id)) return this.v[i]; return null; };



  /* ------------------------------------------------------ widget */

  function Widget(root) {

    var no = root.querySelector('[data-ewc-bundle-config]');

    var d = JSON.parse(no.textContent);

    this.root = root; this.cfg = d.cfg || {}; this.produto = d.produto; this.fmt = d.moneyFormat; this.rotas = d.rotas || {};

    this.raiz = ((window.Shopify && Shopify.routes && Shopify.routes.root) || this.rotas.raiz || '/').replace(/\/?$/, '/');

    this.vars = new Variantes(this.produto);

    this.barras = this.cfg.barras || [];

    this.selecionada = Math.max(1, Math.min(this.barras.length, parseInt(this.cfg.preselecionada || 1, 10))) - 1;

    this.unidades = [];   // [barraIndex][unidade] = escolha (array de valores de opção)
    this.qtds = {};       // [barraIndex] = quantidade escolhida no seletor da barra (barras com `seletor`)

    this.extras = {};     // dados de produto dos upsells/brindes por handle

    this.ocupado = false;

    this.form = achar(root, this.cfg.seletor_formulario);

    if (!this.form) throw new Error('formulário de compra não encontrado');

    this.aplicarEstilo(); this.montar();

    if (!posicionar(root, this.form)) throw new Error('não achei onde encaixar o widget');

    // quando a barra escolhe a variante, o seletor do tema some junto: deixar os dois

    // na tela é convidar o cliente a pedir uma variante que a barra não vai mandar

    var barraEscolheVariante = this.barras.some(function (b) { return !!b.variante_id; });

    if (this.cfg.esconder_seletor_do_tema !== false && this.vars.v.length > 1 &&

        (this.cfg.variantes_diferentes !== false || barraEscolheVariante)) this.esconderPicker();

    this.ligar(); this.render(); this.carregarExtras();

  }

  /* Cada chave de `estilo` vira uma variavel CSS. Os nomes espelham o que o app de

     bundle guarda no deal (fundo da barra escolhida e da outra, cor do preco, do preco

     riscado, tamanho de cada texto), para a config da loja poder ser copiada 1:1. */

  var ESTILO = {

    cor_destaque: '--eb-acento', cor_selo: '--eb-selo', fundo_barra: '--eb-fundo',

    fundo_selecionada: '--eb-fundo-sel', anel: '--eb-anel', fonte: '--eb-fonte',

    cor_texto: '--eb-texto', cor_suave: '--eb-suave', cor_titulo: '--eb-titulo',

    cor_subtitulo: '--eb-sub', cor_preco: '--eb-preco', cor_preco_cheio: '--eb-preco-cheio',

    fundo_brinde: '--eb-fundo-brinde', anel_brinde: '--eb-anel-brinde',

    fundo_brinde_travado: '--eb-fundo-travado', anel_brinde_travado: '--eb-anel-travado',

    anel_selecionada: '--eb-anel-sel', anel_bolinha: '--eb-anel-bolinha', cor_selo_texto: '--eb-selo-texto',
    fundo_etiqueta: '--eb-fundo-etiqueta', cor_etiqueta: '--eb-cor-etiqueta',
    cor_destaque_texto: '--eb-destaque-texto', cor_destaque_icone: '--eb-destaque-icone',

    peso_subtitulo: '--eb-peso-sub', peso_titulo: '--eb-peso-titulo', peso_preco: '--eb-peso-preco',

    respiro_upsell: '--eb-respiro-upsell', anel_campo: '--eb-anel-campo', caixa_traco: '--eb-caixa-traco',

    cor_brinde_travado: '--eb-cor-travado', fundo_upsell: '--eb-fundo-upsell',

    fundo_faixa: '--eb-fundo-faixa', cor_faixa: '--eb-cor-faixa',

    peso_titulo_bloco: '--eb-peso-titulo-bloco', espacamento_titulo_bloco: '--eb-ls-titulo-bloco',

    fundo_faixa_escolhida: '--eb-fundo-faixa-sel', cor_faixa_escolhida: '--eb-cor-faixa-sel'

  };

  var ESTILO_PX = {

    raio: '--eb-raio', vao: '--eb-vao', brinde_foto: '--eb-brinde-foto',

    fonte_titulo: '--eb-f-titulo', fonte_subtitulo: '--eb-f-sub', fonte_selo: '--eb-f-selo',

    fonte_preco: '--eb-f-preco', fonte_preco_cheio: '--eb-f-preco-cheio',

    fonte_brinde: '--eb-f-brinde', fonte_upsell: '--eb-f-upsell',

    fonte_titulo_brindes: '--eb-f-titulo-brindes', bolinha: '--eb-bolinha', barra_foto: '--eb-barra-foto',

    foto_raio: '--eb-foto-raio', vao_brindes: '--eb-vao-brindes', raio_campo: '--eb-raio-campo',
    fonte_etiqueta: '--eb-f-etiqueta', raio_etiqueta: '--eb-raio-etiqueta',
    fonte_destaque: '--eb-f-destaque', icone_destaque: '--eb-icone-destaque', vao_destaques: '--eb-vao-destaques',

    caixa: '--eb-caixa', caixa_raio: '--eb-caixa-raio',

    faixa_foto: '--eb-faixa-foto', faixa_foto_raio: '--eb-faixa-foto-raio',

    fonte_faixa: '--eb-f-faixa', fonte_faixa_cheio: '--eb-f-faixa-cheio',

    tamanho_titulo_bloco: '--eb-f-titulo-bloco',

    unidade_foto: '--eb-unidade-foto', unidade_foto_raio: '--eb-unidade-foto-raio',

    respiro_topo: '--eb-respiro-topo', foto_upsell: '--eb-foto-upsell'

  };

  Widget.prototype.aplicarEstilo = function () {

    var e = this.cfg.estilo || {}, r = this.root.style;

    Object.keys(ESTILO).forEach(function (k) { if (e[k]) r.setProperty(ESTILO[k], e[k]); });

    Object.keys(ESTILO_PX).forEach(function (k) { if (e[k] != null) r.setProperty(ESTILO_PX[k], e[k] + 'px'); });

    if (e.barras_por_linha) r.setProperty('--eb-colunas', String(e.barras_por_linha));

    if (e.brindes_por_linha) r.setProperty('--eb-colunas-brinde', String(e.brindes_por_linha));

    this.root.classList.toggle('ewc-bundle--empilhado', e.barra_layout === 'empilhado');

    this.root.classList.toggle('ewc-bundle--fita', e.selo_estilo === 'fita');

    this.root.classList.toggle('ewc-bundle--faixa-upsell', !!this.cfg.upsell_em_todas_as_barras);

    // o DESENHO da faixa nao depende do comportamento: e' chave propria

    this.root.classList.toggle('ewc-bundle--upsell-faixa', (e.upsell_faixa !== false));

    this.root.classList.toggle('ewc-bundle--selo-inline', e.selo_estilo === 'inline');

    // o estilo.css vai para o FIM do body: na PDP a folha do kit (link no fim do body) vinha DEPOIS do widget e
    // vencia as regras do estilo por ordem; no fim do body o estilo e' sempre a ultima folha
    if (e.css) {
      var jaTem = Array.prototype.some.call(document.querySelectorAll('style[data-ewc-estilo]'), function (s) { return s.textContent === e.css; });
      if (!jaTem) { var st = el('style'); st.setAttribute('data-ewc-estilo', ''); st.textContent = e.css; document.body.appendChild(st); }
    }

  };

  Widget.prototype.esconderPicker = function () {

    var f = this.form, secao = f.closest('.shopify-section,section,[id^="shopify-section"]') || document;

    secao.querySelectorAll(SEL_PICKER).forEach(function (n) { if (!n.closest('.ewc-bundle')) n.classList.add('ewc-esconde-seletor'); });

  };

  Widget.prototype.variantePadrao = function () {

    var b = this.barras[this.selecionada];

    if (b && b.variante_id) { var fixa = this.vars.porId(b.variante_id); if (fixa) return fixa; }

    var id = this.form.querySelector('[name="id"]'); var v = id && this.vars.porId(id.value);

    if (!v) v = this.vars.v.filter(function (x) { return x.disponivel; })[0] || this.vars.v[0];

    return v;

  };

  Widget.prototype.precoUnitario = function () { var v = this.variantePadrao(); return v ? v.preco : 0; };

  Widget.prototype.compareUnitario = function () { var v = this.variantePadrao(); return v && v.compare > v.preco ? v.compare : 0; };



  Widget.prototype.montar = function () {

    var self = this, cfg = this.cfg;

    this.root.querySelectorAll(':scope > :not(script):not(style)').forEach(function (n) { n.remove(); });  // o <style> do estilo.css fica

    if (cfg.titulo_bloco) this.root.appendChild(el('div', 'ewc-bundle__titulo', cfg.titulo_bloco));

    this.caixaBarras = el('div', 'ewc-bundle__barras');

    this.root.appendChild(this.caixaBarras);

    this.nosBarras = [];

    this.barras.forEach(function (b, i) {

      var lab = el('label', 'ewc-bundle__barra'); lab.setAttribute('data-ewc-bar', i + 1);

      var radio = el('input'); radio.type = 'radio'; radio.name = 'ewc-bundle-bar'; radio.value = String(i);

      lab.appendChild(radio);

      // a etiqueta da barra ('SAVE 40%') fica solta no topo, vira fita, ou entra na

      // linha do título — quem decide é `estilo.selo_estilo`

      var seloNo = b.selo ? el('span', 'ewc-bundle__selo', b.selo) : null;

      var seloNaLinha = (cfg.estilo || {}).selo_estilo === 'inline';

      if (seloNo && !seloNaLinha) lab.appendChild(seloNo);

      var cab = el('div', 'ewc-bundle__cabeca');

      if ((cfg.estilo || {}).bolinha !== 0) cab.appendChild(el('span', 'ewc-bundle__bolinha'));

      // barra que representa um pacote mostra a foto daquele pacote (a foto da variante)

      if ((cfg.estilo || {}).barra_foto && b.imagem) {

        var cx = el('div', 'ewc-bundle__barra-foto'); var fi = el('img'); fi.src = b.imagem; fi.alt = b.titulo || '';

        fi.loading = 'lazy'; cx.appendChild(fi); cab.appendChild(cx);

      }

      var tx = el('div', 'ewc-bundle__textos');

      var nome = el('div', 'ewc-bundle__nome'); nome.textContent = b.titulo || (b.q + ' un');

      if (b.etiqueta) nome.appendChild(el('span', 'ewc-bundle__etiqueta', b.etiqueta));

      if (seloNo && seloNaLinha) nome.appendChild(seloNo);

      tx.appendChild(nome);

      if (b.subtitulo) { var sub = el('div', 'ewc-bundle__sub'); sub.innerHTML = b.subtitulo; tx.appendChild(sub); }

      cab.appendChild(tx);

      var pr = el('div', 'ewc-bundle__precos'); pr.appendChild(el('span', 'ewc-bundle__preco')); pr.appendChild(el('span', 'ewc-bundle__cheio'));

      cab.appendChild(pr); lab.appendChild(cab);
      // lista de destaques da barra (os 'highlights' do app: check + texto, um por linha)
      if (b.destaques && b.destaques.length) {
        var ds = el('div', 'ewc-bundle__destaques');
        b.destaques.forEach(function (t) {
          if (!t) return;
          var it = el('div', 'ewc-bundle__destaque');
          var ic = el('span', 'ewc-bundle__destaque-icone');
          ic.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M13.3307 4L5.9974 11.3333L2.66406 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
          it.appendChild(ic); it.appendChild(el('span', 'ewc-bundle__destaque-txt', t)); ds.appendChild(it);
        });
        lab.appendChild(ds);
      }

      // seletor de quantidade dentro da barra (o `quantitySelector` do app): q da barra é o mínimo,
      // só a barra escolhida mostra o −/+, e preço, unidades e carrinho seguem a quantidade escolhida
      var qi = null;
      if (b.seletor) {
        var qs = el('div', 'ewc-bundle__qtd');
        var bm = el('button', 'ewc-bundle__qtd-b'); bm.type = 'button'; bm.setAttribute('data-ewc-qtd', '-'); bm.setAttribute('aria-label', 'Decrease quantity');
        bm.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M1.2 5h7.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        qi = el('input', 'ewc-bundle__qtd-i'); qi.type = 'number'; qi.min = String(b.q); if (b.maximo) qi.max = String(b.maximo); qi.step = '1';
        qi.value = String(b.q); qi.setAttribute('inputmode', 'numeric'); qi.setAttribute('data-ewc-qtd', 'campo'); qi.setAttribute('aria-label', 'Quantity'); qi.setAttribute('data-ewc-injected', '1');
        var bp = el('button', 'ewc-bundle__qtd-b'); bp.type = 'button'; bp.setAttribute('data-ewc-qtd', '+'); bp.setAttribute('aria-label', 'Increase quantity');
        bp.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M5 1.2v7.6M1.2 5h7.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        qs.appendChild(bm); qs.appendChild(qi); qs.appendChild(bp); lab.appendChild(qs);
      }
      var un = el('div', 'ewc-bundle__unidades'); lab.appendChild(un);

      var ex = el('div', 'ewc-bundle__extras'); lab.appendChild(ex);

      // faixa de brinde colada no pe da barra (o "free gift" que a referencia desenha

      // dentro do proprio cartao, e nao numa caixa separada). So aparece na barra que

      // ganha o brinde, e o texto vem do arquivo, nunca montado por conta.

      var faixa = null;

      if (b.brinde_faixa) {

        faixa = el('div', 'ewc-bundle__faixa');

        faixa.setAttribute('data-ewc-faixa', b.brinde_faixa.handle || '');

        var ffoto = el('div', 'ewc-bundle__faixa-foto'); faixa.appendChild(ffoto);

        faixa.appendChild(el('span', 'ewc-bundle__faixa-txt', b.brinde_faixa.texto || ''));

        faixa.appendChild(el('span', 'ewc-bundle__faixa-cheio'));

        lab.appendChild(faixa);

      }

      self.caixaBarras.appendChild(lab);

      self.nosBarras.push({ lab: lab, radio: radio, preco: pr.firstChild, cheio: pr.lastChild, unidades: un, extras: ex, faixa: faixa, qtd: qi });

      self.unidades[i] = [];

    });

    if (this.quadroDeBrindes()) {

      this.noBrindes = el('div', 'ewc-bundle__brindes');

      if (cfg.titulo_brindes) {

        var cabB = el('div', 'ewc-bundle__brindes-cabeca');

        var tit = el('span', 'ewc-bundle__brindes-titulo'); tit.innerHTML = cfg.titulo_brindes;

        cabB.appendChild(tit); this.noBrindes.appendChild(cabB);

      }

      this.listaBrindes = el('div', 'ewc-bundle__brindes-lista');

      this.noBrindes.appendChild(this.listaBrindes);

      this.root.appendChild(this.noBrindes);

    }

    this.propriedade = el('input'); this.propriedade.type = 'hidden'; this.propriedade.name = 'properties[_ewc_bundle]'; this.propriedade.setAttribute('data-ewc-injected', '1');

    this.form.appendChild(this.propriedade);

  };



  /* Barra com `seletor`: a quantidade da barra (q) é o MÍNIMO; a pessoa escolhe quantas quer no −/+
     e tudo (preço, unidades, propriedade, carrinho) segue a quantidade escolhida. Sem `seletor`, é q. */
  Widget.prototype.qtdDe = function (b) {
    var i = typeof b === 'number' ? b : this.barras.indexOf(b); b = this.barras[i];
    if (!b) return 1;
    if (!b.seletor) return b.q;
    var q = parseInt(this.qtds[i], 10); if (!q || q < b.q) q = b.q;
    if (b.maximo && q > b.maximo) q = b.maximo;
    return q;
  };
  Widget.prototype.definirQtd = function (i, q) {
    var b = this.barras[i]; if (!b || !b.seletor) return;
    q = parseInt(q, 10); if (!q || q < b.q) q = b.q; if (b.maximo && q > b.maximo) q = b.maximo;
    this.qtds[i] = q; if (this.selecionada !== i) this.selecionada = i;
    this.render();
  };
  /* O preço de uma barra sai SEMPRE do que a vitrine serve, nunca do número gravado

     na config. Numa loja cuja vitrine converte a moeda (base em libra vendendo em

     dólar, por exemplo) o número da config está na moeda base: mostrá-lo com o

     símbolo da moeda do cliente anuncia um preço que o checkout não cobra. A

     porcentagem da barra viaja justamente para a conta poder ser refeita aqui. */

  Widget.prototype.precosDaBarra = function (b, qtd) {

    var v = b.variante_id ? this.vars.porId(b.variante_id) : null;

    var unit = v ? v.preco : this.precoUnitario();

    var cmp = v ? (v.compare > v.preco ? v.compare : 0) : this.compareUnitario();

    var total, qn = qtd || this.qtdDe(b);

    if (unit && b.pct != null) total = Math.round(unit * qn * (100 - b.pct) / 100);

    else if (unit && !b.desconto_titulo) total = unit * qn;          // barra sem desconto

    else { total = b.total != null ? Math.round(b.total * 100) : unit * b.q; if (qn !== b.q) total = Math.round(total / b.q) * qn; }   // seletor: preço de cada unidade da barra vezes a quantidade escolhida

    return { unidade: unit, compare: cmp, total: total, cada: Math.round(total / qn), qtd: qn };

  };

  Widget.prototype.render = function () {

    var self = this, cfg = this.cfg;

    this.barras.forEach(function (b, i) {

      var n = self.nosBarras[i], sel = i === self.selecionada;

      n.lab.classList.toggle('is-selected', sel); n.radio.checked = sel;

      var pr = self.precosDaBarra(b), p = pr.unidade, cmp = pr.compare;

      var usarCompare = (cfg.mostrar || {}).usar_compare_at !== false && cmp > 0;

      var total = pr.total, cada = pr.cada;

      var cheioTotal = (usarCompare ? cmp : p) * pr.qtd;
      if (n.qtd) {
        if (n.qtd.value !== String(pr.qtd)) n.qtd.value = String(pr.qtd);
        n.qtd.previousSibling.disabled = pr.qtd <= b.q;                          // '−' morre no mínimo (como o app)
        n.qtd.nextSibling.disabled = !!(b.maximo && pr.qtd >= b.maximo);
      }

      if ((cfg.mostrar || {}).por_unidade) {

        n.preco.textContent = self.money(cada) + ' each';

        var cheioCada = usarCompare ? cmp : p;

        n.cheio.textContent = cheioCada > cada ? self.money(cheioCada) : '';

      } else {

        n.preco.textContent = self.money(total);

        n.cheio.textContent = cheioTotal > total ? self.money(cheioTotal) : '';

      }
      // subtítulo com {{economia}} (o 'You save {{saved_total}}' do Kaching): cheio da barra menos o total
      if (b.subtitulo && b.subtitulo.indexOf('{{economia}}') >= 0) {
        var barraEl = n.preco.closest('.ewc-bundle__barra'); var subEl = barraEl && barraEl.querySelector('.ewc-bundle__sub');
        if (subEl) subEl.textContent = b.subtitulo.replace('{{economia}}', self.money(Math.max(0, cheioTotal - total)));
      }

      if (sel) self.renderUnidades(i); else n.unidades.innerHTML = '';

      // a referencia mostra a linha de upsell em TODA barra, escolhida ou nao;

      // o que so aparece na escolhida e' a caixinha de marcar e o seletor de cor

      if (self.cfg.upsell_em_todas_as_barras) self.renderExtras(i, sel);

      else if (sel) self.renderExtras(i, true);

      else n.extras.innerHTML = '';

    });

    this.sincronizarGaleria();

    this.atualizarForm();

  };



  Widget.prototype.renderUnidades = function (i) {

    var self = this, b = this.barras[i], n = this.nosBarras[i], cont = n.unidades;

    cont.innerHTML = '';

    if (b.variante_id) return;

    if (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) return;

    var padrao = this.variantePadrao();

    // um rótulo só, com o nome da opção, quando a config pede — é o desenho do app

    var porOpcao = (this.cfg.rotulo_unidades || '') === 'opcao';

    if (porOpcao) cont.appendChild(el('div', 'ewc-bundle__unidades-rotulo', this.vars.opcoes.join(' · ')));

    // Com um rótulo só (o nome da opção), a referência NÃO numera as unidades:

    // são duas linhas iguais, cada uma com a foto e o seletor. O número só existe

    // quando não há rótulo de opção para orientar a pessoa.

    var numerar = !porOpcao;

    var qn = this.qtdDe(i);
    for (var u = 0; u < qn; u++) {

      if (!this.unidades[i][u]) this.unidades[i][u] = padrao.opcoes.slice();

      var linha = el('div', 'ewc-bundle__unidade');

      if (numerar) linha.appendChild(el('span', 'ewc-bundle__unidade-n', '#' + (u + 1)));

      // a referencia poe a foto da variante escolhida ao lado do seletor

      var caixaFoto = null;

      if (self.cfg.foto_na_unidade !== false) {

        caixaFoto = el('div', 'ewc-bundle__unidade-foto');

        var vAtual = self.vars.porOpcoes(self.unidades[i][u]);

        if (vAtual && vAtual.imagem) {

          var fu = el('img'); fu.src = vAtual.imagem; fu.alt = ''; fu.loading = 'lazy';

          caixaFoto.appendChild(fu);

        }

        linha.appendChild(caixaFoto);

      }

      this.vars.opcoes.forEach(function (nomeOpcao, k) {

        var escolha = self.unidades[i][u];

        var valores = self.vars.valoresDisponiveis(k, escolha);

        var swatch = self.cfg.swatches && self.cfg.swatches.opcao && self.cfg.swatches.opcao.toLowerCase() === String(nomeOpcao).toLowerCase() && self.cfg.swatches.cores;

        if (swatch) {

          var grupo = el('div', 'ewc-bundle__swatches'); grupo.setAttribute('role', 'radiogroup'); grupo.setAttribute('aria-label', nomeOpcao);

          valores.forEach(function (x) {

            var s = el('span', 'ewc-bundle__swatch'); s.title = x.valor; s.style.background = self.cfg.swatches.cores[x.valor] || '#ccc';

            s.classList.toggle('is-on', escolha[k] === x.valor); s.classList.toggle('is-off', !x.disponivel);

            s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-val', x.valor); s.setAttribute('data-ewc-un', u);

            grupo.appendChild(s);

          });

          linha.appendChild(grupo);

        } else {

          var s = el('select'); s.setAttribute('data-ewc-opt', k); s.setAttribute('data-ewc-un', u); s.setAttribute('aria-label', nomeOpcao);

          valores.forEach(function (x) { var o = el('option', null, x.valor + (x.disponivel ? '' : ' (Sold out)')); o.value = x.valor; o.disabled = !x.disponivel; s.appendChild(o); });

          s.value = escolha[k];

          linha.appendChild(s);

        }

      });

      cont.appendChild(linha);

    }

  };



  Widget.prototype.renderExtras = function (i, escolhida) {

    var self = this, n = this.nosBarras[i], cont = n.extras; cont.innerHTML = '';

    if (escolhida === undefined) escolhida = (i === this.selecionada);

    var ups = (this.cfg.upsells || []).filter(function (u) { return !u.por_barra || !u.por_barra.length || u.por_barra.indexOf(i + 1) !== -1; });

    ups.forEach(function (u, ordem) {

      // duas partes, como no app: a linha do produto e o bloco de preço. Numa barra

      // estreita o preço desce sozinho para a segunda linha.

      // cada upsell precisa de chave propria: a mesma housse aparece duas vezes

      // na mesma barra da referencia, e as duas sao marcaveis em separado

      var chave = u.id || (u.handle + '#' + (i + 1) + '#' + ordem);

      // <div>, nunca <label>: label dentro de label engole o clique da barra

      var linha = el('div', 'ewc-bundle__extra');

      linha.setAttribute('data-ewc-extra', chave);

      var principal = el('div', 'ewc-bundle__extra-main');

      if (escolhida) {

        var cb = el('input'); cb.type = 'checkbox';

        cb.setAttribute('data-ewc-upsell', u.handle);

        cb.setAttribute('data-ewc-chave', chave);

        if (u.quantidade) cb.setAttribute('data-ewc-qtd', String(u.quantidade));

        var lembrado = self.marcados && self.marcados[chave];

        cb.checked = (lembrado === undefined) ? !!u.pre_marcado : !!lembrado;

        principal.appendChild(cb);

      }

      var d = self.extras[u.handle];

      var vEscolhida = null;

      if (d && d.variantes) {

        var alvo = (self.varExtra && self.varExtra[chave]) || (d.variante && String(d.variante));

        for (var q = 0; q < d.variantes.length; q++) {

          if (String(d.variantes[q].id) === String(alvo)) { vEscolhida = d.variantes[q]; break; }

        }

      }

      var fotoDaLinha = (vEscolhida && vEscolhida.imagem) || (d && d.imagem);

      if (fotoDaLinha) {

        var im = el('img'); im.src = fotoDaLinha; im.alt = '';

        im.setAttribute('data-ewc-extra-foto', chave);

        principal.appendChild(im);

      }

      principal.appendChild(el('span', 'ewc-bundle__extra-txt', u.texto || (d ? d.titulo : u.handle)));

      // o seletor de cor do upsell so aparece na barra escolhida, como na referencia

      if (escolhida && d && d.variantes && d.variantes.length > 1) {

        var sv = el('select', 'ewc-bundle__extra-var');

        sv.setAttribute('data-ewc-extra-var', chave);

        d.variantes.forEach(function (v) {

          var o = el('option', null, v.titulo); o.value = String(v.id);

          o.disabled = !v.disponivel; sv.appendChild(o);

        });

        var escolhido = (self.varExtra && self.varExtra[chave]) || (d.variante && String(d.variante));

        if (escolhido) sv.value = String(escolhido);

        principal.appendChild(sv);

      }

      linha.appendChild(principal);

      var precos = el('div', 'ewc-bundle__extra-preco');

      if (u.gratis) {

        precos.appendChild(el('span', 'ewc-bundle__extra-gratis', u.rotulo || self.money(0)));

        var risc = self.riscadoDe(u, d);

        if (risc) precos.appendChild(el('span', 'ewc-bundle__cheio', self.money(risc)));

      } else {

        // preco do upsell: o do arquivo quando houver, senao o da vitrine

        var pv = (u.preco != null && u.preco !== '') ? Math.round(u.preco * 100) : (d ? d.preco : null);

        if (pv != null) precos.appendChild(el('span', 'ewc-bundle__extra-gratis', self.money(pv)));

        var rc = self.riscadoDe(u, d);

        if (rc) precos.appendChild(el('span', 'ewc-bundle__cheio', self.money(rc)));

      }

      linha.appendChild(precos); cont.appendChild(linha);

    });

    if (this.quadroDeBrindes()) { this.renderQuadroDeBrindes(i); return; }

    var faixaDaBarra = (this.barras[i] || {}).brinde_faixa;

    (this.cfg.brindes || []).forEach(function (g) {

      // o brinde que ja aparece na faixa do pe da barra nao se repete aqui

      if (faixaDaBarra && faixaDaBarra.handle === g.handle) return;

      // so_barras: a linha só aparece nas barras listadas (1-based) — é o "free gift por barra" do Kaching
      if (g.so_barras && g.so_barras.length && g.so_barras.indexOf(i + 1) === -1) return;

      var livre = (i + 1) >= (g.a_partir_da_barra || 1);

      var linha = el('div', 'ewc-bundle__extra' + (livre ? '' : ' is-locked') + (g.handle ? '' : ' is-texto')); linha.setAttribute('data-ewc-gift', g.handle || '');

      var d = self.extras[g.handle];

      var imgSrc = g.imagem || (d && d.imagem);

      if (imgSrc) { var im = el('img'); im.src = imgSrc; im.alt = ''; linha.appendChild(im); }

      var txt = el('span', null, (g.texto || (d ? d.titulo : g.handle)) + ' ');

      if (g.rotulo !== '') txt.appendChild(el('span', 'ewc-bundle__extra-gratis', livre ? (g.rotulo || 'FREE') : (self.cfg.textos && self.cfg.textos.travado || 'Locked')));

      if (d && d.compare) txt.appendChild(el('span', 'ewc-bundle__cheio', self.money(d.compare)));

      linha.appendChild(txt); cont.appendChild(linha);

    });

  };



  /* Preenche foto e preco riscado de cada faixa de brinde. O riscado e' o preco do

     produto original multiplicado pela quantidade daquela barra - que e' o que a

     referencia mostra (2 housses = 59,80, com a housse a 29,90). */

  Widget.prototype.preencherFaixas = function () {

    var self = this;

    (this.nosBarras || []).forEach(function (no, i) {

      var cfgF = self.barras[i] && self.barras[i].brinde_faixa;

      if (!no.faixa || !cfgF) return;

      var d = self.extras[cfgF.handle];

      if (!d) return;

      var cx = no.faixa.querySelector('.ewc-bundle__faixa-foto');

      if (cx && !cx.firstChild && d.imagem) {

        var im = el('img'); im.src = d.imagem; im.alt = ''; im.loading = 'lazy'; cx.appendChild(im);

      }

      var alvo = no.faixa.querySelector('.ewc-bundle__faixa-cheio');

      if (alvo && cfgF.mostrar_preco !== false) {

        // o riscado da faixa e' o preco de TABELA do produto de origem (o que a

        // referencia mostra), nao o preco da copia a preco zero. Vem da vitrine

        // para acompanhar a moeda que o cliente esta vendo.

        var fonte = cfgF.riscado_de ? self.extras[cfgF.riscado_de] : d;

        if (!fonte) return;

        var unit = (cfgF.riscado_campo === 'preco') ? fonte.preco : (fonte.compare || fonte.preco || 0);

        var tot = unit * (cfgF.qtd || 1);

        alvo.textContent = tot ? self.money(tot) : '';

      }

    });

  };



  /* A galeria do tema segue a cor escolhida: acha a miniatura cuja imagem tem o

     mesmo nome de arquivo da variante e a aciona. Funciona no Dawn e em qualquer

     tema cuja galeria troque no clique da miniatura. */

  Widget.prototype.sincronizarGaleria = function () {

    if (this.cfg.seguir_galeria === false) return;

    var v = this.vars.porOpcoes(this.unidades[this.selecionada] && this.unidades[this.selecionada][0] || []);

    if (!v || !v.imagem) return;

    var nome = String(v.imagem).split('/').pop().split('?')[0].replace(/_\d+x\d*(?=\.)/, '');

    if (!nome || this._ultimaFoto === nome) return;

    this._ultimaFoto = nome;

    var limpa = function (u) { return String(u || '').split('/').pop().split('?')[0].replace(/_\d+x\d*(?=\.)/, ''); };

    // 1) a miniatura da galeria

    var minis = document.querySelectorAll('.thumbnail-list__item img, .product__media-item img, [data-media-id] img');

    for (var i = 0; i < minis.length; i++) {

      if (limpa(minis[i].currentSrc || minis[i].src) !== nome) continue;

      var botao = minis[i].closest('.thumbnail, button, a, [data-media-id]');

      if (botao && botao.click) { botao.click(); return; }

    }

    // 2) sem miniatura: troca direto a foto grande

    var grandes = document.querySelectorAll('.product__media img, media-gallery img');

    for (var k = 0; k < grandes.length; k++) {

      var r = grandes[k].getBoundingClientRect();

      if (r.width > 300) { grandes[k].src = v.imagem.replace(/_\d+x\d*(?=\.)/, '_1200x'); return; }

    }

  };



  Widget.prototype.quadroDeBrindes = function () {

    return this.cfg.brindes_layout === 'quadro' && (this.cfg.brindes || []).length > 0;

  };



  /* O quadro de brindes da referencia: uma fileira de cartoes abaixo das barras,

     cada um com foto, nome, a palavra FREE e o preco de tabela riscado. */

  Widget.prototype.renderQuadroDeBrindes = function (i) {

    var self = this, lista = this.listaBrindes;

    if (!lista) return;

    lista.innerHTML = '';

    (this.cfg.brindes || []).forEach(function (g) {

      var livre = (i + 1) >= (g.a_partir_da_barra || 1);

      var d = self.extras[g.handle];

      var cartao = el('div', 'ewc-bundle__brinde' + (livre ? '' : ' is-locked'));

      cartao.setAttribute('data-ewc-gift', g.handle);

      // o selo fica por cima da borda de cima do cartao, centrado

      var selo = el('div', 'ewc-bundle__brinde-selo');

      selo.appendChild(el('span', 'ewc-bundle__brinde-selo-txt', livre ? (g.rotulo || 'FREE') : (self.cfg.textos && self.cfg.textos.travado || 'Locked')));

      var risc = self.riscadoDe(g, d) || (d && (d.compare || d.preco));

      if (risc) selo.appendChild(el('span', 'ewc-bundle__brinde-selo-cheio', self.money(risc)));

      cartao.appendChild(selo);

      var foto = el('div', 'ewc-bundle__brinde-foto');

      if (d && d.imagem) { var im = el('img'); im.src = d.imagem; im.alt = d.titulo || ''; foto.appendChild(im); }

      cartao.appendChild(foto);

      cartao.appendChild(el('div', 'ewc-bundle__brinde-nome', d ? d.titulo : g.handle));

      lista.appendChild(cartao);

    });

  };



  /* `riscado` diz QUAL preço mostrar cortado, não qual número: "tabela" é o preço de

     tabela do produto de origem e "preco" é o preço dele — os dois lidos da vitrine, que

     entrega tudo na moeda que o cliente está vendo. Número solto na config continua

     aceito, e vale onde a vitrine não converte. */

  Widget.prototype.riscadoDe = function (x, d) {

    var r = x.riscado;

    if (typeof r === 'string' && r && x.origem) {

      var o = this.extras[x.origem];

      if (!o) return 0;

      return r === 'tabela' ? (o.compare || o.preco) : o.preco;

    }

    if (r != null && r !== '') return Math.round(r * 100);

    return (d && d.compare) || 0;

  };

  Widget.prototype.carregarExtras = function () {

    var self = this, handles = [];

    (this.barras || []).forEach(function (bb) {

      var f = bb.brinde_faixa;

      if (f && f.riscado_de && handles.indexOf(f.riscado_de) === -1) handles.push(f.riscado_de);

    });

    (this.cfg.upsells || []).concat(this.cfg.brindes || []).forEach(function (x) {

      if (x.handle && handles.indexOf(x.handle) === -1) handles.push(x.handle);

      // o upsell risca o preço de tabela do produto ORIGINAL: esse número tem que vir da

      // vitrine também, senão não acompanha a moeda que o cliente está vendo

      if (x.origem && typeof x.riscado === 'string' && handles.indexOf(x.origem) === -1) handles.push(x.origem);

    });

    handles.forEach(function (h) {

      fetch(self.raiz + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {

        if (!p) return;

        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || p.variants[0];

        self.extras[h] = { titulo: p.title, preco: v ? v.price : 0, compare: v && v.compare_at_price > v.price ? v.compare_at_price : (v && v.price === 0 && v.compare_at_price ? v.compare_at_price : 0),

                           variante: v ? v.id : null, imagem: (p.featured_image || '').replace(/(\.[a-z]+)(\?.*)?$/i, '_300x300$1$2'),

                           // a lista inteira alimenta o seletor de cor do upsell

                           variantes: (p.variants || []).map(function (x) {

                             // a foto da variante alimenta a troca de cor na linha de upsell

                             var fi = (x.featured_image && x.featured_image.src) || p.featured_image || '';

                             return { id: x.id, titulo: x.title, disponivel: !!x.available,

                                      imagem: String(fi).replace(/(\.[a-z]+)(\?.*)?$/i, '_300x300$1$2') };

                           }) };

        // toda barra precisa do redesenho: a linha de upsell aparece em todas e

        // so agora a foto e o preco do produto existem

        if (self.cfg.upsell_em_todas_as_barras) {

          (self.nosBarras || []).forEach(function (_, k) { self.renderExtras(k, k === self.selecionada); });

        } else {

          self.renderExtras(self.selecionada);

        }

        self.preencherFaixas();

      }).catch(function () {});

    });

  };



  // propriedades de linha preenchidas pelo cliente (campos do formulario, inclusive
  // os que ficam fora dele e se ligam pelo atributo form=). Sem isto, o que a pessoa
  // digita — nome do negocio, numero de locais — nao chega ao pedido.
  Widget.prototype.propsDoFormulario = function () {
    var out = {};
    if (!this.form || !this.form.elements) return out;
    Array.prototype.forEach.call(this.form.elements, function (c) {
      if (!c.name || c.getAttribute && c.getAttribute('data-ewc-injected')) return;
      var m = /^properties\[(.+)\]$/.exec(c.name);
      if (!m) return;
      if ((c.type === 'checkbox' || c.type === 'radio') && !c.checked) return;
      var v = (c.value == null ? '' : String(c.value)).trim();
      if (!v) return;
      out[m[1]] = v;
    });
    return out;
  };

  Widget.prototype.itens = function () {

    var b = this.barras[this.selecionada], contagem = {}, ordem = [], qn = this.qtdDe(this.selecionada);

    var padrao = this.variantePadrao();

    if (b.variante_id) {

      contagem[b.variante_id] = qn; ordem.push(b.variante_id);

    } else for (var u = 0; u < qn; u++) {

      var v = (this.cfg.variantes_diferentes === false || this.vars.v.length <= 1) ? padrao : (this.vars.porOpcoes(this.unidades[this.selecionada][u] || padrao.opcoes) || padrao);

      if (!(v.id in contagem)) { contagem[v.id] = 0; ordem.push(v.id); }

      contagem[v.id]++;

    }

    var extras = this.propsDoFormulario();
    var itens = ordem.map(function (id) {
      var pr = { _ewc_bundle: b.titulo || String(qn) };
      for (var k in extras) { if (Object.prototype.hasOwnProperty.call(extras, k)) pr[k] = extras[k]; }
      return { id: parseInt(id, 10), quantity: contagem[id], properties: pr };
    });

    var self = this;

    this.root.querySelectorAll('[data-ewc-upsell]:checked').forEach(function (cb) {

      var h = cb.getAttribute('data-ewc-upsell'), d = self.extras[h];

      var chave = cb.getAttribute('data-ewc-chave') || h;

      var qtd = parseInt(cb.getAttribute('data-ewc-qtd'), 10) || 1;

      var vid = (self.varExtra && self.varExtra[chave]) || (d && d.variante);

      if (vid) itens.push({ id: parseInt(vid, 10), quantity: qtd, properties: { _ewc_upsell: '1' } });

    });

    var fx = (this.barras[this.selecionada] || {}).brinde_faixa;

    (this.cfg.brindes || []).forEach(function (g) {

      if (!g.handle) return; // brinde de texto: nada entra no carrinho

      // a faixa da barra manda na quantidade; sem faixa, vale o a_partir_da_barra com 1 unidade

      var qtd = (fx && fx.handle === g.handle) ? (fx.qtd || 1) : null;

      if (qtd === null) {

        if ((self.selecionada + 1) < (g.a_partir_da_barra || 1)) return;

        qtd = 1;

      }

      var vid = g.variante_id || (self.extras[g.handle] && self.extras[g.handle].variante);

      if (vid) itens.push({ id: parseInt(vid, 10), quantity: qtd, properties: { _ewc_gift: '1' } });

    });

    return itens;

  };



  Widget.prototype.atualizarForm = function () {

    var b = this.barras[this.selecionada], qn = this.qtdDe(this.selecionada); this.propriedade.value = b.titulo || String(qn);

    var distintos = {}; this.itens().forEach(function (i) { if (!i.properties._ewc_upsell && !i.properties._ewc_gift) distintos[i.id] = 1; });

    var multi = Object.keys(distintos).length > 1 || qn > 1;

    this.form.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);

    var sec = this.form.closest('.shopify-section,section'); if (sec) sec.classList.toggle('ewc-multi-variant', multi && this.cfg.esconder_expresso !== false);

    var bd = this.cfg.botao_dinamico;

    if (bd && bd.modelo) {

      var btn = this.form.querySelector('button[name="add"],[type="submit"]');

      var alvo = btn && (btn.querySelector('span') || btn);

      if (alvo) {

        if (!btn.hasAttribute('data-ewc-texto-original')) btn.setAttribute('data-ewc-texto-original', alvo.textContent);

        var pr = this.precosDaBarra(b);

        var cheio = (pr.compare || pr.unidade) * pr.qtd;

        var economia = Math.max(0, cheio - pr.total);

        var novo = economia > 0 ? bd.modelo.replace('{{economia}}', this.money(economia)) : btn.getAttribute('data-ewc-texto-original');

        if (alvo.textContent !== novo) alvo.textContent = novo;

      }

    }

  };



  Widget.prototype.ligar = function () {

    var self = this;

    this.root.addEventListener('change', function (ev) {

      var t = ev.target;

      if (t.getAttribute && t.getAttribute('data-ewc-qtd') === 'campo') { var lq = t.closest('.ewc-bundle__barra'); self.definirQtd(parseInt(lq.getAttribute('data-ewc-bar'), 10) - 1, parseInt(t.value, 10)); return; }
      if (t.name === 'ewc-bundle-bar') { self.selecionada = parseInt(t.value, 10); self.render(); return; }

      if (t.tagName === 'SELECT' && t.hasAttribute('data-ewc-opt')) {

        var k = parseInt(t.getAttribute('data-ewc-opt'), 10), u = parseInt(t.getAttribute('data-ewc-un'), 10);

        var esc = self.unidades[self.selecionada][u]; esc[k] = t.value;

        for (var j = k + 1; j < self.vars.opcoes.length; j++) { var vals = self.vars.valoresDisponiveis(j, esc); if (!vals.some(function (x) { return x.valor === esc[j]; })) esc[j] = (vals.filter(function (x) { return x.disponivel; })[0] || vals[0] || {}).valor; }

        self.renderUnidades(self.selecionada); self.atualizarForm(); return;

      }

      if (t.hasAttribute('data-ewc-upsell')) {

        self.marcados = self.marcados || {};

        // a chave e' por LINHA, nao por produto: a mesma housse pode aparecer

        // duas vezes na mesma barra e cada uma se marca sozinha

        self.marcados[t.getAttribute('data-ewc-chave') || t.getAttribute('data-ewc-upsell')] = t.checked;

        self.atualizarForm();

      }

      if (t.hasAttribute('data-ewc-extra-var')) {

        self.varExtra = self.varExtra || {};

        var ch = t.getAttribute('data-ewc-extra-var');

        self.varExtra[ch] = t.value;

        // a foto pequena da linha segue a cor escolhida

        var linhaFoto = self.root.querySelector('[data-ewc-extra-foto="' + ch + '"]');

        var linha = t.closest('[data-ewc-extra]');

        var h = linha ? (linha.querySelector('[data-ewc-upsell]') || {}).getAttribute : null;

        var handle = linha && linha.querySelector('[data-ewc-upsell]')

              ? linha.querySelector('[data-ewc-upsell]').getAttribute('data-ewc-upsell') : null;

        var dd = handle ? self.extras[handle] : null;

        if (linhaFoto && dd && dd.variantes) {

          for (var z = 0; z < dd.variantes.length; z++) {

            if (String(dd.variantes[z].id) === String(t.value) && dd.variantes[z].imagem) {

              linhaFoto.src = dd.variantes[z].imagem; break;

            }

          }

        }

        self.atualizarForm();

      }

    });

    this.root.addEventListener('click', function (ev) {

      var qb = ev.target.closest && ev.target.closest('[data-ewc-qtd="-"],[data-ewc-qtd="+"]');
      if (qb) { ev.preventDefault(); var lb = qb.closest('.ewc-bundle__barra'), ib = parseInt(lb.getAttribute('data-ewc-bar'), 10) - 1; self.definirQtd(ib, self.qtdDe(ib) + (qb.getAttribute('data-ewc-qtd') === '+' ? 1 : -1)); return; }
      var s = ev.target.closest && ev.target.closest('.ewc-bundle__swatch'); if (!s) return;

      ev.preventDefault();

      var k = parseInt(s.getAttribute('data-ewc-opt'), 10), u = parseInt(s.getAttribute('data-ewc-un'), 10);

      self.unidades[self.selecionada][u][k] = s.getAttribute('data-ewc-val');

      self.renderUnidades(self.selecionada); self.atualizarForm();

    });

    // digitar no campo: vale assim que for um número válido (>= mínimo); Enter não envia o formulário
    this.root.addEventListener('input', function (ev) {
      var t = ev.target; if (!(t.getAttribute && t.getAttribute('data-ewc-qtd') === 'campo')) return;
      var v = parseInt(t.value, 10), lq = t.closest('.ewc-bundle__barra'), iq = parseInt(lq.getAttribute('data-ewc-bar'), 10) - 1;
      if (v && v >= (self.barras[iq] || {}).q) self.definirQtd(iq, v);
    });
    this.root.addEventListener('keydown', function (ev) {
      var t = ev.target; if (ev.key === 'Enter' && t.getAttribute && t.getAttribute('data-ewc-qtd') === 'campo') { ev.preventDefault(); t.blur(); }
    });
    this.form.addEventListener('submit', function (ev) {

      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); self.comprar();

    }, true);

    this.form.setAttribute('data-ewc-bundle-form', '1');

    var self2 = this; window.addEventListener('pageshow', function () { self2.ocupado = false; var btn = self2.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = false; });

  };



  Widget.prototype.comprar = function () {

    var self = this; if (this.ocupado) return; this.ocupado = true;

    var btn = this.form.querySelector('button[name="add"],[type="submit"]'); if (btn) btn.disabled = true;

    var itens = this.itens();

    // o Dawn precisa das seções da gaveta na resposta do próprio add para

    // conseguir desenhá-la e abri-la; pedir isso não atrapalha outros temas

    var gavetaDawn = document.querySelector('cart-drawer');

    var temRender = gavetaDawn && typeof gavetaDawn.renderContents === 'function';

    var corpo = { items: itens };

    if (temRender) {

      corpo.sections = 'cart-drawer,cart-icon-bubble';

      corpo.sections_url = window.location.pathname;

    }

    fetch(this.raiz + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(corpo) })

      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })

      .then(function (json) {

        document.dispatchEvent(new CustomEvent('ewc:cart:added', { bubbles: true, detail: { items: json.items || [json] } }));

        var depois = self.cfg.depois_de_adicionar || 'gaveta';

        // caminho do Dawn: desenha a gaveta com as seções que vieram e abre

        if (temRender && depois !== 'carrinho' && json && json.sections) {

          try {

            // o Dawn decide onde prender o foco pela classe is-empty do PROPRIO

            // elemento; se ela ficar, o trapFocus recebe null e estoura

            gavetaDawn.classList.remove("is-empty");

            var dentro = gavetaDawn.querySelector(".drawer__inner");

            if (dentro) dentro.classList.remove("is-empty");

            gavetaDawn.renderContents(json);

            return;

          } catch (e) { /* falha aberto: cai no caminho de sempre */ }

        }

        if (depois === 'carrinho' || (depois === 'gaveta' && !window.EwcCart)) {

          ['cart:refresh', 'cart:build', 'cart-drawer:open', 'ajaxProduct:added'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); });

          if (depois === 'carrinho' || !document.querySelector('cart-drawer,.cart-drawer,[data-cart-drawer]')) window.location.href = self.rotas.carrinho || (self.raiz + 'cart');

        }

      })

      .catch(function () { window.location.href = self.rotas.carrinho || (self.raiz + 'cart'); })

      .then(function () { self.ocupado = false; if (btn) btn.disabled = false; });

  };



  function iniciar() {

    document.querySelectorAll('[data-ewc-bundle]').forEach(function (root) {

      if (root._ewc) return;

      try { root._ewc = new Widget(root); window.EwcBundle = root._ewc; } catch (e) { root.hidden = true; if (window.console && console.debug) console.debug('[ewc-bundle] fora do ar:', e.message); }

    });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();

})();

